import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Fade, Backdrop } from '@material-ui/core';

import ButtonBase from '../Buttons/ButtonBase';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 560,
    borderRadius: 4,
    //padding: 16,
    margin: 0,
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
    '@media(max-width: 560px)': {
      width: 328,
    },
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    marginBottom: 23,
    '@media (max-width: 580px)': {
      display: 'none'
    }
  },
  imageMobile: {
    width: '100%',
    marginBottom: 23,
    display: 'none',
    '@media (max-width: 580px)': {
      display: 'block'
    }
  },
  name: {
    fontSize: 24,
    color: '#10587f',
    textAlign: 'center',
    marginBottom: 16,
    fontWeight: 'bold',
    maxWidth: 400,
    '@media(max-width: 560px)': {
      maxWidth: 280,
    },
  },
  subname: {
    fontSize: 14,
    color: '#484848',
    textAlign: 'center',
    maxWidth: 376,
    '@media(max-width: 560px)': {
      maxWidth: 264,
    },
  },
  ButtonBase: {
    margin: '32px 0 48px',
    width: '368px',
    '@media(max-width: 560px)': {
      width: 264,
    },
  },
  closeContainer: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    padding: '16px 16px 6px',
    justifyContent: 'flex-end',
    '@media(max-width: 560px)': {
      marginBottom: 16,
    },
  },
});

const ModalThanksOpinion = ({ open, handleClose }) => {
  const classes = useStyles();

  return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div onClick={handleClose} className={classes.closeContainer}>
              <img src="/img/icons/close.svg" alt="close" />
            </div>
            <div className={classes.infoWrapper}>
              <img
                className={classes.image}
                src="/img/LandingClient/opinions/send-opinion/experiencia.svg"
                alt="gracias"
              />
              <img
                className={classes.imageMobile}
                src="/img/LandingClient/opinions/send-opinion/experiencia-mobile.svg"
                alt="gracias"
              />
              <div>
                <p className={classes.name}>
                  Gracias por compartirnos tu experiencia
                </p>
              </div>

              <div className={classes.subname}>
                <span>
                  Los comentarios que nos dejas son muy valiosos para nosotros.
                  Es por ello que estamos en constante mejora y queremos
                  brindarte la mejor experiencia.
                </span>
              </div>

              <ButtonBase
                type="submit"
                onClick={handleClose}
                variant="primary"
                className={classes.ButtonBase}
                //style={{marginBottom: 48}}
              >
                ¡Listo!
              </ButtonBase>
            </div>
          </div>
        </Fade>
      </Modal>
  );
};

export default ModalThanksOpinion;
